import { make } from 'vuex-pathify'
import axios from 'axios'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'

const state = {
  notifications: {
    data: [],
    count: 0,
    unreadCount: 0,
  },

  loading: false,
}

const mutations = make.mutations(state)

const actions = {
  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/notification?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.notifications = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  remove: ({ state, dispatch }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/notification/${id}`)
      .then(_ => {
        dispatch('get')
        showSuccess('Notificação excluída com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  markRead: ({ state, dispatch }, id) => {
    state.loading = true
    return axios.patch(`${process.env.VUE_APP_API_URL}/notification/${id}/read`)
      .then(() => dispatch('get'))
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
